module.exports = __webpack_public_path__ + "static/ColleenBerube-79e65be1f01f5a0e29af4f75396625ca.jpg";